import { SVGProps } from '@components/Icon/types';

export const Summery = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4, 2)">
      <path
        d="M5.10936 14.0204C5.35805 13.76 5.76319 13.7597 6.0117 14.0204C6.2575 14.2783 6.25713 14.6948 6.0117 14.953L4.64354 16.3885C4.39487 16.6494 3.98987 16.6494 3.7412 16.3885L3.28514 15.91C3.03918 15.6518 3.0391 15.2355 3.28514 14.9774C3.53383 14.717 3.93897 14.7167 4.18748 14.9774L4.19237 14.9823L5.10936 14.0204Z"
        fill={fill}
      />
      <path
        d="M12.2646 14.3036C12.6199 14.3039 12.9002 14.6049 12.9004 14.9657C12.9002 15.3265 12.6199 15.6275 12.2646 15.6278H7.70409C7.34852 15.6278 7.06849 15.3267 7.06834 14.9657C7.06856 14.6047 7.34857 14.3036 7.70409 14.3036H12.2646Z"
        fill={fill}
      />
      <path
        d="M5.10936 10.0604C5.35804 9.80003 5.76318 9.79975 6.0117 10.0604C6.25749 10.3184 6.25715 10.7348 6.0117 10.993L4.64354 12.4286C4.39487 12.6895 3.98987 12.6895 3.7412 12.4286L3.28514 11.95C3.03916 11.6918 3.03909 11.2756 3.28514 11.0174C3.53382 10.7571 3.93896 10.7568 4.18748 11.0174L4.19237 11.0223L5.10936 10.0604Z"
        fill={fill}
      />
      <path
        d="M12.2646 10.3436C12.6199 10.3439 12.9002 10.6449 12.9004 11.0057C12.9002 11.3665 12.6199 11.6675 12.2646 11.6678H7.70409C7.34854 11.6678 7.06851 11.3667 7.06834 11.0057C7.06856 10.6447 7.34857 10.3436 7.70409 10.3436H12.2646Z"
        fill={fill}
      />
      <path
        d="M5.10936 6.09555C5.35803 5.83499 5.76324 5.83465 6.0117 6.09555C6.25754 6.35397 6.25721 6.7715 6.0117 7.03013L4.64354 8.4686C4.39493 8.72994 3.9899 8.72978 3.7412 8.4686L3.28514 7.98911C3.03923 7.73051 3.03917 7.3131 3.28514 7.05454C3.53383 6.79385 3.939 6.7935 4.18748 7.05454L4.19139 7.05942L5.10936 6.09555Z"
        fill={fill}
      />
      <path
        d="M12.2646 6.37973C12.62 6.38006 12.9002 6.68164 12.9004 7.04282C12.9002 7.40407 12.6201 7.70558 12.2646 7.70591H7.70409C7.34835 7.70591 7.06848 7.40427 7.06834 7.04282C7.06856 6.68145 7.3484 6.37973 7.70409 6.37973H12.2646Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.95073C16 1.6892 14.9199 0.673161 13.5804 0.673161H11.9329C11.6566 0.269361 11.1754 0 10.6322 0H5.3679C4.8227 0 4.33988 0.27139 4.06407 0.677721L2.33236 0.674602C1.03343 0.717605 0 1.71673 0 2.95073V17.7224C0 18.984 1.08008 20 2.41955 20H13.5805C14.9199 20 16 18.984 16 17.7224V2.95073ZM10.8669 2.74461C10.9969 2.65859 10.9969 2.55308 10.9969 2.55308V1.45963C10.9969 1.45963 10.9969 1.35108 10.9177 1.28728C10.7776 1.17432 10.6322 1.19845 10.6322 1.19845H5.3679C5.3679 1.19845 5.26326 1.18208 5.13324 1.2681C5.00322 1.35413 5.00321 1.45963 5.00321 1.45963V2.55308C5.00321 2.55308 5.00321 2.66163 5.08236 2.72543C5.2225 2.83839 5.36789 2.81426 5.36789 2.81426H10.6322C10.6322 2.81426 10.7368 2.83064 10.8669 2.74461ZM3.82084 1.9447L2.41966 1.94569C1.82341 1.94569 1.35132 2.39041 1.35132 2.95073L1.35132 17.7224C1.35132 18.2827 1.8233 18.7275 2.41955 18.7275H13.5805C14.1767 18.7275 14.6487 18.2827 14.6487 17.7224L14.6487 2.95073C14.6487 2.39041 14.1767 1.94569 13.5804 1.94569H12.1793V2.55308C12.1793 3.35429 11.4814 4.01271 10.6322 4.01271H5.36789C4.51869 4.01271 3.82084 3.35429 3.82084 2.55308V1.9447Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'clipboard-summary';
